import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import type { FormInstance } from 'antd';
import { Button, Form } from 'antd';
import type { FC } from 'react';
import { ImageUpload } from '../ImageUpload';

interface DynamicImageUploadListProps {
  name: string;
  label: string;
  buttonText: string;
  form: FormInstance<any>;
}

export const DynamicImageUploadList: FC<DynamicImageUploadListProps> = ({
  name,
  label,
  buttonText,
  form,
}) => {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <Form.Item label={label} className="mb-0">
          <div className="flex gap-4 flex-wrap items-center">
            {fields.map((field) => {
              const { key, ...restField } = field;
              return (
                <div key={key} className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <Form.Item key={key} {...restField} className="mb-0">
                      <ImageUpload
                        value={form.getFieldValue([name, field.name])}
                        onSuccess={(url) => {
                          form.setFieldValue([name, field.name], url);
                        }}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      className="text-red-500 cursor-pointer"
                      onClick={() => remove(field.name)}
                    />
                  </div>
                </div>
              );
            })}
            <Button
              style={{ width: 180 }}
              type="dashed"
              onClick={() => add()}
              icon={<PlusOutlined />}
            >
              {buttonText}
            </Button>
          </div>
        </Form.Item>
      )}
    </Form.List>
  );
};
